var map = {
	"./circle.svg": "a744",
	"./cloud.svg": "0b27",
	"./cog.svg": "dd16",
	"./donut.svg": "5cfb",
	"./double_arrow.svg": "0037",
	"./double_star.svg": "a85d",
	"./drop.svg": "5e7f",
	"./heart.svg": "7a92",
	"./hexagon.svg": "50d5",
	"./rectangle.svg": "8440",
	"./rectangle_rounded.svg": "c313",
	"./star.svg": "e8e4",
	"./trapezoid.svg": "2cf8",
	"./triangle.svg": "6bec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1ef";